import React from 'react';
import ModalContainer from '../ModalContainer';
import { AiOutlinePlusCircle } from 'react-icons/ai';
import { PageHeader, StyledWorkflowSection, WorkflowCardHolder } from './WorkflowSection.style';
import Button from '../Button';
import CreateWorkflowModal from './CreateWorkflowModal';
import workflowService from '../../services/workflowService';
import { useQuery } from '@tanstack/react-query';
import Loaders from '../Loaders';
import WorkflowCard from './WorkflowCard';

const WorkflowSection = () => {
  const getAllWorkflows = useQuery({
    queryKey: ['get_all_workflows'],
    queryFn: () => workflowService.getWorkflows(),
    staleTime: Infinity,
  });

  return (
    <StyledWorkflowSection>
      <PageHeader>
        <div className="text-box">
          <h1>Workflows</h1>
          <p>Create a new workflow or select an existing one to get started</p>
        </div>
        <ModalContainer
          width="750"
          title="Create a Workflow"
          content={({ onClose }) => <CreateWorkflowModal onClose={onClose} />}
          btnComponent={({ onClick }) => (
            <Button variant="secondary" width="190px" onClick={onClick}>
              <AiOutlinePlusCircle size="18" /> Create Workflow
            </Button>
          )}
        />
      </PageHeader>
      <div className="text-box">
        <strong className="title">Your Workflows</strong>
      </div>
      {getAllWorkflows?.isPending ? (
        <Loaders loading />
      ) : (
        <WorkflowCardHolder>
          <WorkflowCard workflowCardsData={getAllWorkflows?.data?.workflows} />
        </WorkflowCardHolder>
      )}
    </StyledWorkflowSection>
  );
};

export default WorkflowSection;
